import {Navigate, Outlet, Route, Routes} from "react-router-dom";
import {AppShell} from "./components/AppShell";
import {LoginPage} from "./pages/LoginPage";
import {NewTaskPage} from "./pages/NewTaskPage";
import {TaskDetailPage} from "./pages/TaskDetailPage";
import {TaskListPage} from "./pages/TaskListPage";
import {getAccessToken} from "./session";

const ProtectedLayout = () => getAccessToken() ? <AppShell><Outlet /></AppShell> : <Navigate to="/login" replace />;
const LoginRoute = () => getAccessToken() ? <Navigate to="/tasks" replace /> : <LoginPage />;

export const App = () => (
  <Routes>
    <Route path="/login" element={<LoginRoute />} />
    <Route element={<ProtectedLayout />}>
      <Route path="/tasks" element={<TaskListPage />} />
      <Route path="/trash" element={<TaskListPage trashed />} />
      <Route path="/tasks/new" element={<NewTaskPage />} />
      <Route path="/tasks/:id" element={<TaskDetailPage />} />
    </Route>
    <Route path="*" element={<Navigate to="/tasks" replace />} />
  </Routes>
);
